import React from "react";
import PropTypes from "prop-types";
const ImageAddIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-4 0h24v24H-4z" />
      <path d="M0 0h20v20H0z" />
      <g>
        <circle
          cx="5.5"
          cy="9.5"
          r="1.5"
          fill={color || "var(--color-easil-gray-x-dark)"}
        />
        <path
          fill={color || "var(--color-easil-gray-x-dark)"}
          d="M17 3h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0V5h-2a1 1 0 1 1 0-2h2V1a1 1 0 1 1 2 0v2z"
        />
        <path
          fill={color || "var(--color-easil-gray-x-dark)"}
          fillRule="nonzero"
          d="M15 11a1 1 0 0 1 2 0v6a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h6a1 1 0 1 1 0 2H3a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-6z"
        />
        <circle
          cx="5.5"
          cy="9.5"
          r="1.5"
          fill={color || "var(--color-easil-gray-x-dark)"}
        />
        <path
          fill={color || "var(--color-easil-gray-x-dark)"}
          fillRule="nonzero"
          d="M14.017 14.108a3 3 0 0 0-3.916.54L7.19 18H14a1 1 0 0 0 1-1v-2.245l-.983-.647zm1.1-1.67l1.433.943a1 1 0 0 1 .45.835V17a3 3 0 0 1-3 3H5a1 1 0 0 1-.755-1.655l4.345-5.009a5 5 0 0 1 6.527-.899z"
        />
      </g>
    </g>
  </svg>
);
ImageAddIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default ImageAddIcon;
